<template>
  <div>
    <ClientUploadInputs
      :shown-errors="shownErrors"
      :uploads="editableUploads"
      @editUpload="editUpload"
      @removeUpload="removeUpload"
      @fieldsValidated="setErrors"
    />
    <FilePicker class="no-padding-override" @fileChange="addUpload" />
  </div>
</template>

<script>
import { Component } from 'vue-property-decorator'
import FilePicker from '@/components/FilePicker.vue'

import ClientUploadInputs from '@/components/ClientUploads/ClientUploadInputs.vue'
import EditModal from '@/components/EditModal.vue'
import ClientUpload from './Mixins/ClientUpload'

@Component({
  components: {
    ClientUploadInputs,
    EditModal,
    FilePicker
  }
})
export default class ClientUploadUpdateList extends ClientUpload {
}
</script>

<style scoped lang="scss" src="../../styles/shared/new-prototype.scss"></style>
<style scoped lang="scss">
  .no-padding-override {
    padding: 0;
  }
</style>
